module.exports = __webpack_public_path__ + "687d5a5607ecbfccbb3be3feae0b3ea1.woff2";